import React, { ReactNode, Fragment, useRef } from "react";
import { CloseIcon } from "@/icons/primary";
import { Dialog, Transition } from "@headlessui/react";
import classNames from "classnames";

export type CaModalProps = {
  isOpen: boolean;
  onClose?: () => void;
  width?: number;
  title?: ReactNode;
  closeIcon?: boolean;
  children: React.ReactNode;
  centered?: boolean;
};

function CaModal({
  isOpen,
  onClose,
  width,
  title,
  closeIcon = true,
  children,
  centered,
}: CaModalProps) {
  const cancelButtonRef = useRef(null);

  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog
        as='div'
        className='relative z-10'
        initialFocus={cancelButtonRef}
        onClose={() => onClose && onClose()}
      >
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-50'
          leave='ease-in duration-200'
          leaveFrom='opacity-50'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-black opacity-60' />
        </Transition.Child>

        <div className='fixed inset-0 z-10 w-screen overflow-y-auto'>
          <div
            className={classNames(
              centered && "h-full",
              `flex min-h-full  justify-center text-center items-center p-0`,
            )}
          >
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 translate-y-0 scale-95'
              enterTo='opacity-100 translate-y-0 scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 translate-y-0 scale-100'
              leaveTo='opacity-0 translate-y-0 scale-95'
            >
              <Dialog.Panel
                className='relative transform bg-white text-left shadow-xl transition-all my-8 w-full rounded-base p-8'
                style={{
                  maxWidth: width ? `${width}px` : "600px",
                }}
              >
                <div className='flex justify-between'>
                  <div className='text-xl font-semibold font-sans-serif mb-8'>{title}</div>

                  {closeIcon && (
                    <div className='cursor-pointer' onClick={onClose}>
                      <CloseIcon style={{ fontSize: "24px" }} />
                    </div>
                  )}
                </div>
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default CaModal;
